import React, { Component } from 'react';
import Axios from 'axios';
import Pagination from 'react-js-pagination';
import Company from 'components/Regions/Company';
import { BASE_URL } from '../../utils/constants';

export default class CompaniesPage extends Component {
  state = {
    companies: [],
    pageNumber: 1,
    activePage: 1,
    total: 0,
    currentRegion: ''
  };

  componentDidMount() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const region = params.get('region');
    this.setState({ currentRegion: region });

    Axios.get(
      `${BASE_URL}/api/company?page=${this.state.pageNumber}&region=${region}`
    ).then(({ data }) => {
      this.setState({
        companies: data.data,
        activePage: data.current_page,
        total: data.total
      });
    });
  }

  handlePageChange(pageNumber) {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const region = params.get('region');
    Axios.get(
      `${BASE_URL}/api/company?page=${pageNumber}&region=${region}`
    ).then(({ data }) => {
      window.scrollTo(0, 0);
      this.setState({ companies: data.data, activePage: data.current_page });
    });
  }
  render() {
    return (
      <div className="news-container center-container">
        {this.state.companies &&
          this.state.companies.map(company => {
            return <Company key={company.id} company={company}></Company>;
          })}
        {this.state.companies && (
          <div className="center-container d-flex justify-content-center">
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={12}
              totalItemsCount={this.state.total}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange.bind(this)}
              itemClass="page-item"
              linkClass="page-link"
            />
          </div>
        )}
      </div>
    );
  }
}
